/**
 * Profondeur du clonage
 */
export enum CloneDepth {
  /** Clone uniquement l'item */
  SHALLOW = 'SHALLOW',
  /** Clone l'item + enfants directs (ex: chapitre + leçons) */
  MEDIUM = 'MEDIUM',
  /** Clone l'item + enfants + ressources */
  DEEP = 'DEEP',
}
